import React from 'react';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import ChevronRight from 'common/Icons/ChevronRight';
import Button from 'components/lib/Button';

const Banner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  padding: 20px;
  border-radius: 10px;
  background-color: var(--neutral-colors-gray-10);
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Title = styled.span`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const NewBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--competitor-purple);
  color: var(--white);
  font-size: 10px;
  font-family: var(--font-bold);
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

const Subtitle = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: var(--text-secondary);
`;

const ViewAllButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 10px 20px;
  height: auto;

  &.ant-btn-primary,
  &.ant-btn-primary:hover,
  &.ant-btn-primary:focus,
  &.ant-btn-primary:active {
    background-color: var(--button-blue) !important;
    border-color: var(--button-blue) !important;
    color: var(--white) !important;
  }
`;

type Props = {
  runId: number;
};

const CommunitiesToWatchPromoBanner = ({ runId }: Props) => {
  const navigate = useNavigate();

  return (
    <Banner>
      <img src="/images/communities-to-watch-promo.png" width={111} height={54} alt="" />
      <Content>
        <TitleRow>
          <Title>Communities to Watch</Title>
          <NewBadge>NEW</NewBadge>
        </TitleRow>
        <Subtitle>Explore the new AI-powered view designed for communities that need attention.</Subtitle>
      </Content>
      <ViewAllButton type="primary" onClick={() => navigate(`/communities-to-watch?runId=${runId}`)}>
        View All Communities
        <ChevronRight fill="var(--white)" width={16} height={16} />
      </ViewAllButton>
    </Banner>
  );
};

export default CommunitiesToWatchPromoBanner;
